import React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const StatChip: React.FC<{
  label: string;
  count: number;
  icon: React.ReactNode;
  to?: string;
}> = ({ label, count, icon, to }) => {
  const cls = cn(
    "flex items-center gap-2 px-3 py-2 rounded-xl border text-sm transition-colors",
    count > 0 && to
      ? "bg-gray-50 dark:bg-gray-950 border-gray-200 dark:border-gray-700 hover:bg-blue-50 dark:hover:bg-blue-950 hover:border-blue-200 dark:hover:border-blue-900 cursor-pointer"
      : "bg-gray-50 dark:bg-gray-950 border-gray-100 dark:border-gray-800 opacity-60 cursor-default"
  );

  const inner = (
    <>
      <span className="text-gray-400 dark:text-gray-500">{icon}</span>
      <span className="font-semibold text-gray-700 dark:text-gray-200 min-w-0 truncate">{label}</span>
      <span className="ml-auto font-bold text-blue-500 tabular-nums dark:text-indigo-300">{count}</span>
    </>
  );

  if (count > 0 && to) return <Link to={to} className={cls}>{inner}</Link>;
  return <div className={cls}>{inner}</div>;
};

export default StatChip;
